import { RegisterInterestParams } from '@marketertechnologies/property-picker';
import axios from 'axios';

import storage from '~/storage';

type LambdaLeadRegisterInterestEndpointParams = {
  fullName: string;
  phoneNumber: string;
  email: string;
  referer?: string;
  projectExternalId?: string;
  unitExternalId: string;
  message?: string;
  source: 'property-picker';
};

const getReferer = () => {
  try {
    return window.sessionStorage.getItem('parentHref') ?? undefined;
  } catch (e) {
    return storage().get('parentHref') ?? undefined;
  }
};

type UseRegisterInterestArgs = {
  projectUuid?: string;
  searchParams?: URLSearchParams;
};

const mutateAsync =
  (args: UseRegisterInterestArgs) => async (unitUuid: string, values: RegisterInterestParams) => {
    const { projectUuid, searchParams } = args;

    const endpointParams: LambdaLeadRegisterInterestEndpointParams = {
      fullName: values.name,
      phoneNumber: values.phone,
      email: values.email,
      referer: getReferer(),
      projectExternalId: projectUuid,
      unitExternalId: unitUuid,
      message: values.comment,
      source: 'property-picker',
      ...Object.fromEntries(searchParams ?? []),
    };

    try {
      return await axios.post(import.meta.env.VITE_LEADS_URL, endpointParams);
    } catch (e) {
      return Promise.reject(e);
    }
  };

export const useRegisterInterest = (args: UseRegisterInterestArgs) => ({
  mutateAsync: mutateAsync(args),
});
